import { Tooltip, TooltipProps } from '@mui/material'
import React from 'react'
import { makeStyles } from 'tss-react/mui'

type CustomPopperProps = {
  TooltipComponent: React.ReactElement<any> | string
  AnchorComponent: React.ReactElement<any>
  disableCloseOnBlur?: boolean
  isOpen?: boolean
  disablePortal?: boolean
  placement?: 'bottom' | 'top' | 'left' | 'right'
  overflowElementId?: string
  tooltipProps?: Partial<TooltipProps>
  /** keeps the tooltip open no metter what */
  debug?: boolean
}

const useStyles = makeStyles()((theme) => ({
  tooltip: {
    backgroundColor: theme.palette.background.paper,
    maxWidth: 'max-content',
    padding: 0,
  },
}))

export const CustomPopper = (props: CustomPopperProps) => {
  const [open, setOpen] = React.useState(props.isOpen ?? false)

  const { classes } = useStyles()

  return (
    <Tooltip
      title={props.TooltipComponent}
      open={open || props.debug || false}
      onClose={() => setOpen(props.debug ?? false)}
      onOpen={() => setOpen(true)}
      placement={props.placement || 'bottom'}
      enterDelay={500}
      enterNextDelay={500}
      arrow
      slotProps={{
        popper: {
          disablePortal: props.disablePortal,
          style: {
            zIndex: 10000,
          },
          popperOptions: {
            modifiers: [
              {
                name: 'flip',
                options: {
                  fallbackPlacements: ['top', 'bottom'],
                },
              },
              {
                name: 'preventOverflow',
                options: {
                  padding: 8,
                  boundary: props.overflowElementId
                    ? document.getElementById(props.overflowElementId)
                    : null,
                },
              },
            ],
          },
        },
      }}
      classes={{
        tooltip: classes.tooltip,
      }}
      {...props.tooltipProps}
    >
      {props.AnchorComponent}
    </Tooltip>
  )
}
